<template>
  <v-data-table
    no-data-text="Nenhuma indisponibilidade disponível"
    :headers="headers"
    :items="items"
    :loading="isGetIndisponibilidadesLoading"
    :footer-props="{
      'items-per-page-text': 'Linhas por página',
      'page-text': '{0}-{1} de {2}',
      'items-per-page-all-text': 'Todos',
    }"
  >
    <template #item.periodoInicial="{ item }">
      {{ functions.converterDateTimeStringEmLocaleDateTimeString(item.periodoInicial) }}
    </template>

    <template #item.periodoFinal="{ item }">
      {{ functions.converterDateTimeStringEmLocaleDateTimeString(item.periodoFinal) }}
    </template>

    <template #item.actions="{ item }">
      <v-btn
        icon
        class="mr-2"
        @click="selecionarItem(item)"
      >
        <v-icon>
          {{ icons.mdiCog }}
        </v-icon>
      </v-btn>

      <v-btn
        icon
        color="error"
        @click="deleteItem(item)"
      >
        <v-icon>
          {{ icons.mdiDelete }}
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { storeToRefs } from 'pinia'
import { mdiCog, mdiDelete } from '@mdi/js'
import AgenteService from '@/services/modules/AgenteService'
import useUserStore from '@/store/user'
import { converterDateTimeStringEmLocaleDateTimeString } from '@/utils/dateTime'

export default {
  emits: ['update:indisponibilidade-selecionada', 'excluir-indisponibilidade'],

  props: {
    items: {
      type: Array,
      required: true,
    },
    isGetIndisponibilidadesLoading: Boolean,
  },

  setup(_, { emit }) {
    const { id: agenteId } = storeToRefs(useUserStore())

    function selecionarItem(item) {
      emit('update:indisponibilidade-selecionada', item)
    }

    async function deleteItem(item) {
      await AgenteService.excluirIndisponibilidadeAgente(agenteId.value, item.id)
      emit('excluir-indisponibilidade', item.id)
    }

    const headers = [
      { text: 'Data Hora - Início', value: 'periodoInicial' },
      { text: 'Data Hora - Fim', value: 'periodoFinal' },
      { text: 'Ações', value: 'actions', align: 'center' },
    ]

    return {
      selecionarItem,
      deleteItem,
      headers,
      functions: {
        converterDateTimeStringEmLocaleDateTimeString,
      },
      icons: {
        mdiCog,
        mdiDelete,
      },
    }
  },
}
</script>
